<template>
    <div class="query-record">
        <el-card class="box-card flex-1 marginT-20">
            <div slot="header" class="flex">
                <span class="fw-bold fc-333">二维码获取记录</span>
                <span style='font-size: 12px; padding-left: 6px; color: #F56C6C;'>（该记录仅保存7天，重要数据建议您下载存到本地）</span>
            </div>
            <div>
                <div class="table">
                    <el-table :data="tableData" border>
                        <el-table-column prop="id" label="编号"></el-table-column>
                        <el-table-column prop="result_data.douyin_mark" label="抖音号"></el-table-column>
                        <el-table-column prop="result_data.phone" label="手机号"></el-table-column>
                        <el-table-column prop="result_data.password" label="二维码状态">
                            <template slot-scope='scope'>
                                <span>{{dyCheckInfo.qrStatus[scope.row.result_data.status]}}</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column label="生成内容">-->
                        <!--    <template slot-scope='scope'>-->
                        <!--        <span style='overflow: hidden; white-space: nowrap; text-overflow: ellipsis;':title='scope.row.result_data.item_url'>{{scope.row.result_data.item_url}}</span>-->
                        <!--    </template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column prop="result_data.password" label="宝贝链接"></el-table-column>-->
                        <!--<el-table-column label="完成时间" :formatter="row => dateFormatUtils(row.created_at * 1000)"></el-table-column>-->
                        <el-table-column label="操作">
                            <template slot-scope='scope'>
                                <el-button type='text' @click='lookQr(scope.row)'>查看二维码</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages marginT-20 text-center">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="5"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog
            :visible.sync="qrDialog"
            width="540px"
            title='二维码'
            :close-on-click-modal="true"
            :show-close="false">
            <div class='flex items-center' style='justify-content: center;'>
                <div class="qrRecordCode" ref="qrRecordCode" id="qrRecordCode"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import pagination from '@/index/mixin/pagination'
import { dyCheckInfo } from '../../../config'

export default {
    mixins: [pagination],

    data() {
        return {
            dyCheckInfo,
            searchForm: {
                invokeName: 'tiktokurl',
                psize: 5,
            },
            tableData: [],
            tableUrl: '/tool/accounts/invoke-log',
            qrDialog: false,
        }
    },
    methods: {
        lookQr(row) {
            const qrUrl = row.result_data && row.result_data.item_url
            this.qrDialog = true;
            this.$nextTick(() => {
                this.qrcode(qrUrl)
            })
        },
        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrRecordCode) {
                this.$refs.qrRecordCode.innerHTML = ''
            }

            let qrcode = new QRCode('qrRecordCode', {
                width: 500,
                height: 500,
                text: data,
                // correctLevel: QRCode.CorrectLevel.L
                correctLevel: 3,
            })
            this.$refs.qrRecordCode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrRecordCode.removeAttribute('title')
            }, 100)
        },
    },
    mounted() {
        if (localStorage.token) {
            this.init()
        }

    },
    watch: {
        method(newValue, oldValue) {
            if (newValue) {
                this.searchForm.invokeName = newValue
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
